import './BngTextArea.css';
import React from 'react';

function BngTextArea({ className = '', field, form, ...props }, ref) {
  return <textarea className={`BngTextArea fill-w ${className}`} ref={ref} {...field} {...props} />;
}

export default React.forwardRef(BngTextArea);
